export default {
  'menu.pages': 'Страницы',
  'menu.features': 'Функции',
  'menu.tenants': 'Арендаторы',
  'menu.subscriptions': 'Подписки',
  'menu.adminMarketplace': 'Маркетплейс',
  'menu.adminMarketplaceFeatures': 'Маркетплейс функций',
  'menu.schedulers': 'Планировщики',
  'menu.dashboard': 'Панель',
  'menu.home': 'Главная',
  'menu.roles': 'Роли',
  'menu.profile': 'Профиль',
  'menu.management': 'Управление',
  'menu.logout': 'Выйти',
  'menu.credits': 'Кредиты',
  'menu.revenue': 'Доходы',
  'menu.entitlements': 'Права',
};
